import { render, staticRenderFns } from "./PaymentIcons.vue?vue&type=template&id=4f5fa3e5&scoped=true&"
import script from "./PaymentIcons.vue?vue&type=script&lang=js&"
export * from "./PaymentIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5fa3e5",
  null
  
)

export default component.exports